import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from './oe-interface';
import OEInterfaceAdapter from './oe-interface-adapter';

export default class OEModelStateUpdateEnabledStateDriver extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.counter = 0;
        this.disabled = false;
        this.appliedDisabled = false;
    }

    incDec(i)   {
        if(typeof(i) !== 'number' || i === 0)   return;
        this.counter += i;
        this.updateDisabled();
    }

    inc()   {
        this.incDec(1);
    }

    dec()   {
        this.incDec(-1);
    }

    set(counter)    {
        if(typeof(counter) !== 'number' || counter === this.counter)   return;
        this.counter = counter;
        this.updateDisabled();
    }

    componentDidMount() {
        this.updateAppliedDisabled();
    }

    componentWillUnmount()    {
        this.updateAppliedDisabled(false);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.counter != this.props.counter && nextProps.counter != this.counter)     {
            this.counter = nextProps.counter;
            this.updateDisabled();
        }
    }

    updateDisabled()   {
        let disabled = this.counter > 0;
        if(disabled === this.disabled)  return;
        this.disabled = disabled;
        this.updateAppliedDisabled();
    }

    updateAppliedDisabled(disabled) {
        if(typeof(disabled) !== 'boolean')  disabled = this.disabled;
        if(this.appliedDisabled === disabled || !this.oe.isReady())   return;
        this.appliedDisabled = disabled;
        this.oe.sharedInterface.getUIControllerModelState().setUpdateEnabled(!this.appliedDisabled);
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.updateAppliedDisabled(false);
            this.appliedDisabled = false;
            return;
        }

        this.updateAppliedDisabled();
    }

    render() {
        return (
            <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
        );
    }
}

OEModelStateUpdateEnabledStateDriver.defaultProps = {
    moduleId: '',
    counter: 0
};

OEModelStateUpdateEnabledStateDriver.propTypes = {
    moduleId: PropTypes.string,
    counter: PropTypes.number
};